"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "Operating Chemistry & Alloy Suitability",
    heading: "Verify Material Compatibility for Your Filtration Process",
    lead: "Share your operating temperature, chemical exposure, and required aperture. Our engineering team reviews corrosion limits and recommends the optimal wire mesh alloy.",
    secondaryLabel: "Browse Technical Resources"
  },
  zh: {
    eyebrow: "工艺介质与合金适用性",
    heading: "核定过滤工艺工况的材料介质兼容性",
    lead: "提供您的工作温度、化学介质环境与目标过滤孔径，我们的工程团队将评估耐腐蚀极限并推荐匹配的丝网合金方案。",
    secondaryLabel: "浏览技术资源"
  },
  es: {
    eyebrow: "Química operativa e idoneidad de aleación",
    heading: "Verifique la compatibilidad de material para su proceso de filtración",
    lead: "Comparta la temperatura de trabajo, exposición química y abertura requerida. Nuestro equipo revisará los límites de corrosión para recomendar la aleación óptima.",
    secondaryLabel: "Explorar recursos técnicos"
  },
  de: {
    eyebrow: "Prozesschemie & Werkstoffeignung",
    heading: "Materialkompatibilität für Ihren Filtrationsprozess verifizieren",
    lead: "Übermitteln Sie Einsatztemperatur, chemische Medien und gewünschte Maschenweite. Unser Fachteam prüft Korrosionsgrenzen und empfiehlt die optimale Drahtgewebelegierung.",
    secondaryLabel: "Technische Ressourcen ansehen"
  },
  fr: {
    eyebrow: "Chimie des procédés et adéquation des alliages",
    heading: "Vérifiez la compatibilité des matériaux pour votre procédé de filtration",
    lead: "Précisez votre température de service, les agents chimiques et l'ouverture requise. Nos ingénieurs évaluent la résistance à la corrosion pour orienter le choix d'alliage.",
    secondaryLabel: "Consulter les ressources techniques"
  },
  pt: {
    eyebrow: "Química operacional e adequação da liga",
    heading: "Verifique a compatibilidade de materiais para o seu processo de filtração",
    lead: "Informe a temperatura de operação, a agressividade química e a abertura necessária. Nossa equipe analisa os limites de corrosão e indica a liga ideal.",
    secondaryLabel: "Ver recursos técnicos"
  }
};
export default function QuoteBanner() {
  const {
    lang
  } = useLanguage();
  const copy = pick(lang, copyData);
  return <CtaBand id="quotectabanner" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: copy.secondaryLabel,
    to: "/TechnicalResourcesPage"
  }} />;
}